export default __webpack_public_path__ + "static/media/Justine.38dd6a27.jpg";